import { config, normalizeApiBaseUrl } from '@/shared/config/index';

export const SETTINGS_STORAGE_KEY = 'enmon-inventory-field-settings';

export interface FieldAppSettings {
  apiBaseUrl: string;
  autoSyncEnabled: boolean;
}

export const defaultFieldAppSettings: FieldAppSettings = {
  apiBaseUrl: config.apiBaseUrl,
  autoSyncEnabled: true,
};

export interface AppSettingsRepository {
  load(): Promise<FieldAppSettings>;
  save(settings: FieldAppSettings): Promise<FieldAppSettings>;
}

export function normalizeFieldAppSettings(value: Partial<FieldAppSettings>): FieldAppSettings {
  return {
    apiBaseUrl: normalizeApiBaseUrl(value.apiBaseUrl ?? defaultFieldAppSettings.apiBaseUrl),
    autoSyncEnabled: value.autoSyncEnabled ?? defaultFieldAppSettings.autoSyncEnabled,
  };
}

export function readStoredFieldAppSettings(): FieldAppSettings {
  if (!globalThis.localStorage) {
    return defaultFieldAppSettings;
  }

  const rawValue = globalThis.localStorage.getItem(SETTINGS_STORAGE_KEY);

  if (!rawValue) {
    return defaultFieldAppSettings;
  }

  try {
    return normalizeFieldAppSettings(JSON.parse(rawValue) as Partial<FieldAppSettings>);
  } catch {
    return defaultFieldAppSettings;
  }
}

export class BrowserAppSettingsRepository implements AppSettingsRepository {
  load() {
    return Promise.resolve(readStoredFieldAppSettings());
  }

  save(settings: FieldAppSettings) {
    const normalized = normalizeFieldAppSettings(settings);

    if (globalThis.localStorage) {
      globalThis.localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(normalized));
    }

    return Promise.resolve(normalized);
  }
}

export const appSettingsRepository = new BrowserAppSettingsRepository();

export { normalizeApiBaseUrl };
